import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Column, Text } from 'Components/UI'

import { CheckCircleSvg } from 'Assets/Svg'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'
import { OFFER_URL } from 'Constants/Values'

import { EMAJIN_SECTION_BENEFIT_ITEMS } from './constants'
import { Container, Content, Overflow } from './styles'

function EmajinSectionBenefits() {
  const router = useRouter()

  const handleClick = useCallback(() => {
    router.push(OFFER_URL)
  }, [router])

  return (
    <Container p={[64, 64, 64, 100]}>
      <Overflow />

      <Column
        alignCenter
        gap={[11, 11, 11, 80]}
        maxWidth={LANDING_CONTENT_WIDTH_PX}
      >
        <SubsectionTitle
          centered
          inverse
          maxWidth={1100}
          subtitle="Emajin Golf is a membership-based, golf networking club. We are a community of like-minded golfers and business professionals, providing 3 key things."
          title="The Benefits"
        />

        <Content flexDirection={['column', 'column', 'column', 'row']}>
          {EMAJIN_SECTION_BENEFIT_ITEMS.map(item => (
            <Column alignCenter gap={4} key={item.id} width={[1, 1, 1, 1 / 3]}>
              {CheckCircleSvg()}

              <Text as="h5" bold center inverse screen32>
                {item.title}
              </Text>

              <Text center inverse regular screen18>
                {item.caption}
              </Text>
            </Column>
          ))}
        </Content>

        <Button onClick={handleClick}>Explore Our Membership</Button>
      </Column>
    </Container>
  )
}

export default EmajinSectionBenefits
